import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck, ShieldAlert, Package } from "lucide-react";

export const SellerTrustBadge = ({ sellerId }) => {
  const [t, setT] = useState(null);
  useEffect(() => {
    if (sellerId) api.get(`/trust/seller/${sellerId}`).then(({ data }) => setT(data)).catch(() => {});
  }, [sellerId]);
  if (!t) return null;
  return (
    <div className="mt-4 flex flex-wrap items-center gap-3 text-xs" data-testid="seller-trust-badge">
      {t.verified ? (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/40 text-emerald-400 font-bold">
          <ShieldCheck className="h-3.5 w-3.5" /> Verified seller
        </span>
      ) : (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-neutral-800 border border-neutral-700 text-neutral-400">
          <ShieldAlert className="h-3.5 w-3.5" /> New seller
        </span>
      )}
      {t.delivery_rate != null && (
        <span className="inline-flex items-center gap-1.5 text-neutral-400">
          <Package className="h-3.5 w-3.5" /> {t.delivery_rate}% delivery rate · {t.delivered} delivered
        </span>
      )}
      <span className="text-neutral-500" data-testid="buyer-protection-note">
        🛡️ Buyer protection: confirm delivery on arrival
      </span>
    </div>
  );
};
